<template>
  <div class="payment-type-block">
    <div class="button-block">
      <button @click="changeBlock('depositMoney')" :class="getCss('depositMoney')">{{ getLocalization('DEPOSIT MONEY') }}</button>
      <button @click="changeBlock('transfer')" :class="getCss('transfer')">{{ getLocalization('TRANSFER') }}</button>
    </div>

    <TransferPage
        :is-visible="activeBlock === 'transfer'"
        :user="user"
    ></TransferPage>
  </div>
</template>
<script>

import TransferPage from "../../../web/components/payment/transfer/transferPage.vue";

export default {
  name: 'paymentPage',
  props: ['user'],
  components: {TransferPage},

  data() {
    return {
      activeBlock: 'depositMoney',
    }
  },
  methods: {
    changeBlock(block) {
      this.activeBlock = block;
      const paymentTypeDepositMoney = document.getElementById('payment-type-deposit-money');
      if (this.activeBlock === 'depositMoney') {
        paymentTypeDepositMoney.style.display = 'block';
      } else {
        paymentTypeDepositMoney.style.display = 'none';
      }
    },
    getCss(block) {
      if (block === this.activeBlock) {
        return 'button primary active'
      }

      return 'button --button'
    },
  }
}
</script>

<style scoped lang="scss">
.button-block {
  display: flex;
  justify-content: center;
  margin-bottom: 52px;

  button {
    margin-left: 2px;
    padding: 22px 0 22px 0;
    width: 284px;
  }

  .--button {
    border: 1px solid var(--green-light);
    background: none;
    color: var(--green-light);
  }
}
</style>

